import Base from '../../ts/_base';

export default class Card extends Base  {

    private authorsList: NodeListOf<HTMLElement>
    private cardList: NodeListOf<HTMLElement>

    get ChildSelectors(): {[key: string]: string} {
        return {
            ...this.selectors,
            authorsList: 'ul[title="list of authors"]',
            cardList: '.card .card-content'
        }
    }  

    public initialize(): void {
        this.authorsList = this.queryElm(this.ChildSelectors.authorsList, true) as NodeListOf<HTMLElement>
        this.cardList = this.queryElm(this.ChildSelectors.cardList, true) as NodeListOf<HTMLElement>
        this.authorCounter();
        this.cardAbs();

    }   
    protected authorCounter(): void {
        const elemensList = this.authorsList;

        elemensList.forEach(element => {
            const items = this.queryElm('.list-inline-item:not(.authors-truncate-to-hide):not(.authors-toggle)', true, element) as NodeListOf<HTMLElement>;
            if (items.length == 2) {
                element.classList.add('authors-data-item-2');
            }
            else if (items.length == 3) {
                element.classList.add('authors-data-item-3');
            }
            else if (items.length > 3) {
                element.classList.add('authors-data-item-more');
            }
        });
    }
    protected cardAbs(): void {
        const cardList = this.cardList;

        cardList.forEach((element, index) => {
            const cardExtra = this.queryElm('.card__extra-info', false, element) as HTMLElement;
            const elementID = cardExtra?.id;
            const cardAbsEle = this.queryElm('.card-footer .btn-bookmark.btn-abs', false, element) as HTMLElement;
            cardExtra?.setAttribute('id',`${elementID}_${index}`);
        });
    }
}